import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: 'Онлайн магазин и готов сайт без програмиране',
	blockDesc: 'С Shopiko и Site Builder всичко е готово, а ти се фокусирай върху бизнеса.',
	blockContent:
	  [
		  {
			  page: 'Shopiko',
			  title: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-compare-shop-plans.php">Shopiko</a>',
			  subTitle: 'Онлайн магазин',
			  desc: 'Стартирай собствен онлайн магазин за минути. Не губи време в разработка!',
			  buttonText: 'Тествай безплатно',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'web-hosting-compare-shop-plans.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  },
		  {
			  page: 'SiteBuilderAI',
			  title: '<a href="' + getInitialMeta('siteURL') + 'site-builder-ai.php">Site Builder AI</a>',
			  subTitle: 'Сайт за минути',
			  desc: 'Бързо, лесно и без програмиране. С дизайни адаптирани за мобилни устройства и още!',
			  buttonText: 'Тествай безплатно',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'site-builder-ai.php'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: 'Online store or ready-made website. No coding required.',
	blockDesc: 'With Shopiko and Site Builder, everything is ready - so you can focus on your business.',
	blockContent:
	  [
		  {
			  page: 'Shopiko',
			  title: '<a href="' + getInitialMeta('siteURL') + 'web-hosting-compare-shop-plans.php">Shopiko</a>',
			  subTitle: 'Online Store',
			  desc: 'Launch your own online store in minutes. No time wasted on development!',
			  buttonText: 'Start your free trial',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'web-hosting-compare-shop-plans.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  },
		  {
			  page: 'SiteBuilderAI',
			  title: '<a href="' + getInitialMeta('siteURL') + 'site-builder-ai.php">Site Builder AI</a>',
			  subTitle: 'Website in minutes',
			  desc: 'Fast, easy, and no coding required. Mobile-friendly designs and more!',
			  buttonText: 'Start your free trial',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'site-builder-ai.php'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];